import styled from 'styled-components';

import BadgeNative from '~/components/Badge';

export const Container = styled.div`
  padding: ${props => props.theme.spacings.giga}
    ${props => props.theme.spacings.giga} 0
    ${props => props.theme.spacings.giga};
`;

export const WrapperBadge = styled.div`
  padding-top: ${props => props.theme.spacings.byte};
`;

export const Badge = styled(BadgeNative)`
  margin-right: ${props => props.theme.spacings.kilo};
`;
